module.exports = {"ProgramStatusName":{"label":"Status","source":"programGrid"},"ProgramName":{"label":"Program Name","details":"program.detail"},"ProgramID":"Program ID","ProgramStartDate":"Start Date","ProgramEndDate":"End Date","Location":"Location","ProgramOwner":{"label":"Program Owner","source":"ProgramsListGrid"},"ClientName":"Client Name"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/Programs/Program-sent/model.json
// module id = u2bT
// module chunks = 12